import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./RelatedConceptViewList.scss";
import EmptyField from "UIComponents/EmptyField";
import LockOverlay from "UIComponents/LockOverlay";
import I18nHOC from "UIComponents/I18nHOC";
import classNames from "classnames";
import { WarningTriangleOutlined } from "@toddle-edu/ds-icons";
import { Button } from "@toddle-edu/ds-web";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { getLabelWithArchivedText } from "Utils";
import { isNewPYPConceptsLabelEnabled } from "lib/i18nHelperVariables";
const emptyFieldStyle = {
  containerStyle: {
    border: 0,
  },
};

class RelatedConceptViewList extends PureComponent {
  getGroupedRelatedConceptList = relatedConceptSets => {
    const {
      listStyle,
      groupedValue,
      listItemsStyle,
      listHeaderStyle,
      t,
    } = this.props;

    return _.map(relatedConceptSets, set => {
      const { label = t("common:subject"), id, isArchived = false } = set;
      const value = groupedValue[id];
      const relatedConceptsLabels = _.join(
        _.map(value, item => item.label),
        ", "
      );

      return (
        _.size(value) > 0 && (
          <div className={classes.list} key={id} style={listStyle}>
            <div
              className={classNames("text-label-2", classes.listHeader)}
              style={listHeaderStyle}
            >
              {getLabelWithArchivedText({
                t,
                label,
                isArchived,
              })}
            </div>
            <div
              className={classNames("text-body-1", classes.listItems)}
              style={listItemsStyle}
            >
              {relatedConceptsLabels}
            </div>
          </div>
        )
      );
    });
  };

  checkGroupRelatedConcept = relatedConceptSets => {
    const { groupedValue } = this.props;

    return (
      _.findIndex(
        relatedConceptSets,
        set => _.size(groupedValue[set.id]) > 0
      ) >= 0
    );
  };

  getEmptyComponent = ({ id, hasData }) => {
    const { onEditClick, t, testId } = this.props;
    const onEditClickCallBack = () => onEditClick({ actionId: id });
    return (
      <EmptyField
        title={
          hasData
            ? `${t("addSubjects_label", {
                label:
                  id === "CONCEPT" &&
                  CURRICULUM_TYPE_PYP &&
                  isNewPYPConceptsLabelEnabled()
                    ? t("common:key_concepts_updated")
                    : t(`common:${id}`),
              })}`
            : CURRICULUM_TYPE_PYP && isNewPYPConceptsLabelEnabled()
            ? `${t("add_specified_concepts_with_label", {
                label: t("common:key_concepts_lowercase_updated"),
              })}`
            : `${t("add_key_concepts_with_label", {
                label: t(`common:${id}`),
              })}`
        }
        showAdd={true}
        containerStyle={emptyFieldStyle.containerStyle}
        onAddNewClick={onEditClickCallBack}
        isDisabled={!hasData}
        renderIcon={
          !hasData && (
            <WarningTriangleOutlined variant="subtle" size="x-small" />
          )
        }
        testId={`${testId}-${id}`}
      />
    );
  };

  render() {
    const {
      t,
      mode,
      emptyText,
      readOnly,
      onEditClick,
      mainContainerStyle,
      headerContainerStyle,
      headerLabelStyle,
      groupedRelatedConcepts,
      lockedDynamicFields,
      isHeaderLableHidden,
      renderEmptyViewComponent,
      testId,
    } = this.props;

    const renderComps = _.map(groupedRelatedConcepts, group => {
      const { id, label, relatedConceptSets } = group;

      const showGroupRelatedConcept = this.checkGroupRelatedConcept(
        relatedConceptSets
      );

      if (!showGroupRelatedConcept && mode == "view") {
        return null;
      }
      const lockedField = _.find(lockedDynamicFields, { id });
      const mainContentContainerClasses = classNames(
        { [classes.mainContentContainer]: true },
        { [classes.mainContentContainerViewMode]: mode == "view" }
      );
      const innerContainerClasses = classNames(
        { [classes.innerContainer]: true },
        { [classes.innerContainerViewMode]: mode == "view" }
      );
      const headerLabelClasses = classNames(
        { [classes.headerLabel]: true },
        { "text-label-2": true }
      );
      const mainContainerClasses = classNames(classes.mainContainer, {
        [classes.mainContainerView]: mode == "view",
      });

      const headerContainerClasses = classNames(
        { [classes.headerContainer]: true },
        { [classes.headerContainerViewMode]: mode == "view" }
      );

      return (
        <div
          key={id}
          style={mainContainerStyle}
          className={mainContainerClasses}
        >
          <div className={headerContainerClasses} style={headerContainerStyle}>
            {!isHeaderLableHidden ? (
              <div className={headerLabelClasses} style={headerLabelStyle}>
                {id === "CONCEPT" &&
                CURRICULUM_TYPE_PYP &&
                isNewPYPConceptsLabelEnabled()
                  ? t("common:key_concepts_updated")
                  : t(`common:${id}`)}
              </div>
            ) : null}
            {showGroupRelatedConcept && mode == "edit" && (
              <Button
                onClick={() => onEditClick({ actionId: id })}
                variant={"outlined-subtle"}
                disabled={lockedField}
                testId={`${testId}-edit`}
              >
                {t("common:edit")}
              </Button>
            )}
          </div>
          <div className={mainContentContainerClasses}>
            {showGroupRelatedConcept ? (
              <div className={innerContainerClasses}>
                {this.getGroupedRelatedConceptList(relatedConceptSets)}
              </div>
            ) : mode == "edit" ? (
              this.getEmptyComponent({
                label,
                id,
                hasData: _.get(relatedConceptSets, "length", 0) > 0,
              })
            ) : (
              <div className={classes.emptyText}>
                {t(`common:${emptyText}`)}
              </div>
            )}
            {(lockedField || readOnly) && (
              <LockOverlay userInfo={_.get(lockedField, "userInfo", {})} />
            )}
          </div>
        </div>
      );
    });
    return _.every(renderComps, _.isNull)
      ? renderEmptyViewComponent()
      : renderComps;
  }
}

RelatedConceptViewList.defaultProps = {
  emptyText: "",
  groupedValue: {},
  listItemsStyle: {},
  listHeaderStyle: {},
  mainContainerStyle: {},
  headerContainerStyle: {},
  groupedRelatedConcepts: [],
  isHeaderLableHidden: false,
};

export default I18nHOC({ resource: ["unitPlan", "common"] })(
  RelatedConceptViewList
);
